// App entry point
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import SEOProvider from "@/components/SEOProvider";
import InstallPWAPrompt from "@/components/InstallPWAPrompt";
import GlobalDeviceLimit from "@/components/GlobalDeviceLimit";
import AuthenticatedRedirect from "@/components/AuthenticatedRedirect";
import Index from "./pages/Index";
import Schedule from "./pages/Schedule";
import DraftRankings from "./pages/DraftRankings";

import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import Unsubscribe from "./pages/Unsubscribe";
import KHLPlayoffs from "./pages/KHLPlayoffs";
import MatchCanSwe from "./pages/MatchCanSwe";
import NotFound from "./pages/NotFound";
import SectionSidebar from "@/components/SectionSidebar";
import MobileSidebar from "@/components/MobileSidebar";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <SEOProvider>
              <SectionSidebar />
              <MobileSidebar />
              <Routes>
                <Route path="/" element={
                  <AuthenticatedRedirect>
                    <Index />
                  </AuthenticatedRedirect>
                } />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/draft-rankings" element={<DraftRankings />} />
                {/* Olympics 2026 now integrated into International Tournaments section */}
                <Route path="/auth" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/khl-playoffs" element={<KHLPlayoffs />} />
                <Route path="/matches/can-vs-swe-2026-05-15" element={<MatchCanSwe />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              <InstallPWAPrompt />
              <GlobalDeviceLimit />
            </SEOProvider>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
